import React, { FC } from 'react';

import VerticalAlign from '../VerticalAlign';

import { FixedGridColumnProps } from './FixedGrid.types';
import { getClassNames } from './FixedGridColumn.styles.legacy';

/**
 * `FixedGridColumn`s can be used to render a fixed-width column next to a fluid-width column and should be rendered in
 * a `FixedGridRow`.
 * @deprecated Please use CoreUI's [Flex and FlexItem components](https://yammer-client-storybook.azurewebsites.net/yammer-web-core-ui/?path=/story/layout-flex--overview) instead.
 */

const FixedGridColumn: FC<FixedGridColumnProps> = ({ verticalAlign, children, className, fixed = false, width }) => {
  const { fixedGridColumn } = getClassNames(fixed, width, className);

  const content =
    verticalAlign && verticalAlign !== 'top' ? (
      <VerticalAlign align={verticalAlign}>{children}</VerticalAlign>
    ) : (
      children
    );

  return <div className={fixedGridColumn}>{content}</div>;
};

export default FixedGridColumn;
